import { PaymentRawdataCSVDownloader } from "../../../../../organisms/smart-apply/payment/payment-rawdata/csv-downloader";
import { useServiceProviderPayment3DSecureAuthRawdataHooks } from "./3dsecure-auth-hooks";

type Props = {
  orgId: string;
};

export const ServiceProviderPayment3DSecureAuthRawdata = ({ orgId }: Props) => {
  const {
    isLoading,
    terms,
    internalTerms,
    targetYYYYMM,
    setTargetYYYYMM,
    onDownload,
    onInternalDownload,
  } = useServiceProviderPayment3DSecureAuthRawdataHooks({
    orgId,
  });

  return (
    <div className="pt-2">
      <div className="columns">
        <div className="pr-4">
          <PaymentRawdataCSVDownloader
            hiddenSelectYYYYMM={false}
            buttonText={"CSVダウンロード"}
            isLoading={isLoading}
            terms={terms}
            targetYYYYMM={targetYYYYMM}
            setTargetYYYYMM={setTargetYYYYMM}
            onDownload={() => onDownload(orgId, targetYYYYMM)}
          />
        </div>
        <PaymentRawdataCSVDownloader
          hiddenSelectYYYYMM={true}
          buttonText={"内部CSVダウンロード"}
          isLoading={isLoading}
          terms={internalTerms}
          targetYYYYMM={targetYYYYMM}
          setTargetYYYYMM={setTargetYYYYMM}
          onDownload={() => onInternalDownload(orgId, targetYYYYMM)}
        />
      </div>
    </div>
  );
};
